// biome-ignore-all lint/a11y: TODO - address a11y issues later
import { Check } from "lucide-react";
import type { AvailableFilterField } from "@/hooks/use-available-filter-fields";
import { cn } from "@/lib/utils";

export interface FieldSelectItemProps {
  field: AvailableFilterField;
  isSelected: boolean;
  onSelect: (fieldId: string) => void;
}

export function FieldSelectItem({
  field,
  isSelected,
  onSelect,
}: FieldSelectItemProps) {
  return (
    <div
      key={field.id}
      className={cn(
        "flex items-center cursor-pointer rounded-sm px-2 py-1.5 text-sm hover:bg-accent",
        isSelected && "bg-accent/50",
      )}
      onClick={() => onSelect(field.id)}
    >
      <Check
        className={cn("h-4 w-4 mr-2", isSelected ? "opacity-100" : "opacity-0")}
      />
      <span className="truncate">{field.label}</span>
    </div>
  );
}
